import { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import Button from "@mui/material/Button";
import { LabelWithControl } from "components/common/LabelControl";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";

export const IndividualHeader = ({
  poIdentifier,
  index,
  comments,
  setComments,
  orderDate,
  setOrderDate,
  deliveryDate,
  setDeliveryDate,
  totalCases,
  totalPallets,
  totalBases,
  totalWagons,
}) => {
  const [dialog, setDialog] = useState(false);
  const [poComment, setPOComment] = useState(comments ? comments[0] : "");
  const [poOrderDate, setPOOrderDate] = useState(
    orderDate[0] && !dayjs(orderDate[0]).isBefore(dayjs())
      ? dayjs(orderDate[0])
      : dayjs()
  );
  const [poDeliveryDate, setPODeliveryDate] = useState(
    deliveryDate ? (deliveryDate[0] ? dayjs(deliveryDate[0]) : null) : null
  );
  useEffect(() => {
    setOrderDate((prevDates) => ({
      ...prevDates,
      [index]: dayjs(poOrderDate).format("YYYY-MM-DDTHH:mm:ss"),
    }));
  }, [poOrderDate, index, setOrderDate]);

  useEffect(() => {
    setDeliveryDate((prevDates) => ({
      ...prevDates,
      [index]: poDeliveryDate
        ? dayjs(poDeliveryDate).format("YYYY-MM-DDTHH:mm:ss")
        : null,
    }));
  }, [poDeliveryDate, index, setDeliveryDate]);

  const openComments = () => setDialog(true);
  const closeComments = () => setDialog(false);

  const handleCommentChange = (event) => {
    setPOComment(event.target.value);
  };

  const handleSave = () => {
    closeComments();
    setComments((prevComments) => ({
      ...prevComments,
      [index]: poComment,
    }));
  };

  const disableBeforeOrderDate = (date) => {
    const orderDate = dayjs(poOrderDate);
    const currentDate = dayjs(date);

    return currentDate.isBefore(orderDate, "day");
  };

  return (
    <>
      <Grid container spacing={1} key={poIdentifier}>
        <Grid item xs={12} sm={6} md={3} className="ptPO0">
          <Box
            sx={{
              display: {
                xs: "block",
                sm: "block",
                md: "none",
              },
            }}
          >
            <LabelWithControl label="PO Identifier" />
          </Box>
          <Typography>{poIdentifier}</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={2} className="ptPO0">
          <Box
            sx={{
              display: {
                xs: "block",
                sm: "block",
                md: "none",
              },
            }}
          >
            <LabelWithControl label="Order Date" />
          </Box>
          <DatePicker
            format="YYYY/MM/DD"
            value={poOrderDate}
            onChange={(date) => setPOOrderDate(date)}
            disablePast
            slotProps={{ 
              textField: { 
                size: "small",
                inputProps: { 'data-testid': 'order-date-input' },
               } 
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2} className="ptPO0">
          <Box
            sx={{
              display: {
                xs: "block",
                sm: "block",
                md: "none",
              },
            }}
          >
            <LabelWithControl label="Delivery Date" />
          </Box>
          <DatePicker
            format="YYYY/MM/DD"
            value={poDeliveryDate}
            onChange={(date) => setPODeliveryDate(date)}
            disablePast
            shouldDisableDate={disableBeforeOrderDate}
            slotProps={{ 
              textField: { 
                size: "small",
                inputProps: { 'data-testid': 'delivery-date-input' }, 
              } 
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={1} className="ptPO0">
          <Box
            sx={{
              display: {
                xs: "block",
                sm: "block",
                md: "none",
              },
            }}
          >
            <LabelWithControl label="Total Cases" />
          </Box>
          <Typography>{totalCases ? totalCases[index] : 0}</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={1} className="ptPO0">
          <Box
            sx={{
              display: {
                xs: "block",
                sm: "block",
                md: "none",
              },
            }}
          >
            <LabelWithControl label="Total Pallets" />
          </Box>
          <Typography>{totalPallets ? totalPallets[index] : 0}</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={1} className="ptPO0">
          <Box
            sx={{
              display: {
                xs: "block",
                sm: "block",
                md: "none",
              },
            }}
          >
            <LabelWithControl label="Total Bases" />
          </Box>
          <Typography>{totalBases ? totalBases[index] : 0}</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={1} className="ptPO0">
          <Box
            sx={{
              display: {
                xs: "block",
                sm: "block",
                md: "none",
              },
            }}
          >
            <LabelWithControl label="Total Wagons" />
          </Box>
          <Typography>{totalWagons ? totalWagons[index] : 0}</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={1} className="ptPO0">
          <Box
            sx={{
              display: {
                xs: "block",
                sm: "block",
                md: "none",
              },
            }}
          >
            <LabelWithControl label="Comments" />
          </Box>
          <Button onClick={() => openComments(index)} className="linkButton">
            {!comments || !comments[index] || comments[index] === ""
              ? "Add"
              : "Update"}
          </Button>
        </Grid>
      </Grid>

      <Dialog open={dialog} onClose={closeComments}>
        <div className="dialogStyling">
          <DialogTitle>Comments</DialogTitle>
          <DialogContent>
            <TextField
              multiline
              rows={4}
              variant="outlined"
              fullWidth
              placeholder="Enter comments..."
              value={poComment}
              onChange={handleCommentChange}
            />
          </DialogContent>
          <DialogActions>
            <Button
              className="commonPOButtons"
              variant="contained"
              onClick={handleSave}
              color="primary"
            >
              Save
            </Button>
          </DialogActions>
        </div>
      </Dialog>
    </>
  );
};
